module.exports = "https://www.gc-pro.gnp.com.mx/31a62fb5e0edc418f36a0b73b18602e2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Icon_dentalia1.svg
// module id = 8053
// module chunks = 0